import Skeleton from '@/components/ui/Skeleton'

/*
 * Market · Events before its first response: the LOADED board, block for
 * block, from the loaded components' own box classes so it matches at every
 * width (10 rows, the URL's own default):
 *
 *   search + filters row   44 / 36 @lg   `SearchInput`'s and `SelectTrigger`'s own heights
 *   list + pager           10 flat rows (`ListRow`'s `py-3` + a 41px two-line body + the
 *                          hairline under every row but the last, 66/65), then `Pagination`'s
 *                          own `mt-6` and 44 below `lg` / 32 above
 *
 * No card round the list: the loaded rows are flat on the page. Bars only,
 * no words, so nothing here can be mistaken for the loaded content. The page's
 * own TitleRow is the exception, and ScreenLayout draws it (see EventsScreen).
 */

const ROW_COUNT = 10

/** The search box beside the Type menu and the date chip, all the toolbar's height. */
function ControlRowSkeleton() {
  return (
    <div className="flex flex-col gap-3 @sm:flex-row @sm:items-center @sm:justify-between">
      <Skeleton className="h-11 w-full rounded-md @sm:w-70 lg:h-9" />
      <div className="flex flex-wrap items-center gap-3">
        <Skeleton className="h-11 w-28 rounded-md lg:h-9" />
        <Skeleton className="h-11 w-36 rounded-md lg:h-9" />
      </div>
    </div>
  )
}

/**
 * One EventList row: a 40px kind tile, a two-line title/body over 41px, a
 * trailing date — the same box `ListRowSkeleton` in MarketBoardStates.tsx
 * draws for Market · Overview's own list rows.
 */
function EventRowSkeleton({ last }: { last: boolean }) {
  return (
    <div
      className={
        last
          ? 'flex items-center gap-4 py-3'
          : 'flex items-center gap-4 border-b border-border-subtle py-3'
      }
    >
      <Skeleton className="h-10 w-16 shrink-0 rounded-md" />
      <div className="flex min-w-0 flex-1 flex-col gap-1">
        <Skeleton className="h-4 w-2/3 rounded-xs" />
        <Skeleton className="h-3 w-1/3 rounded-xs" />
      </div>
      <Skeleton className="h-4 w-20 shrink-0 rounded-xs" />
    </div>
  )
}

export function EventsBoardSkeleton() {
  return (
    <>
      <ControlRowSkeleton />
      <div>
        <div>
          {Array.from({ length: ROW_COUNT }, (_, index) => (
            <EventRowSkeleton key={index} last={index === ROW_COUNT - 1} />
          ))}
        </div>
        <div className="mt-6 h-11 lg:h-8" />
      </div>
    </>
  )
}
